import React, { PureComponent, memo } from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal';

class Dialog extends PureComponent {
    render() {
        const {
            disableBackdropClick,
            disableEscapeKeyDown,
            // fullScreen,
            // fullWidth,
            // maxWidth,
            onBackdropClick,
            onEscapeKeyDown,
            children,
            modalStyle,
            onClose,
            open,
        } = this.props;

        // const { showModal } = this.state;
        return (
            <div>
                {open && (
                    <Modal
                        disableBackdropClick={disableBackdropClick}
                        disableEscapeKeyDown={disableEscapeKeyDown}
                        onBackdropClick={onBackdropClick}
                        onEscapeKeyDown={onEscapeKeyDown}
                        onClose={onClose}
                        modalStyle={modalStyle}
                        open={open}
                    >
                        {children}
                    </Modal>
                )}
            </div>
        );
    }
}

Dialog.propTypes = {
    onClose: PropTypes.func,
    open: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
    modalStyle: PropTypes.string.isRequired,
    disableBackdropClick: PropTypes.bool,
    disableEscapeKeyDown: PropTypes.bool,
    onBackdropClick: PropTypes.func,
    onEscapeKeyDown: PropTypes.func,
};

Dialog.defaultProps = {
    disableBackdropClick: false,
    disableEscapeKeyDown: false,
    onClose: () => null,
    onBackdropClick: () => null,
    onEscapeKeyDown: () => null,
};

export default memo(Dialog);
